import React from 'react';
import { useVisitorTracking } from '../hooks/useVisitorTracking';

const Intro = () => {
  const { ref } = useVisitorTracking('intro', {
    threshold: 0.3,
    minDuration: 3
  });

  return (
    <section className="intro" ref={ref}>
      <h1>Welcome, I'M<br /><span className="highlight">Chouchane Med Amine</span></h1>
      <p>Software Developer</p>
    </section>
  );
};

export default Intro;
